var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMenuNotificaciones(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1359",
    "data-name": "Grupo 1359",
    transform: "translate(-4.072 -0.831)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_199",
    "data-name": "Rect\\xE1ngulo 199",
    width: 37,
    height: 35,
    transform: "translate(4.071 0.831)",
    fill: "#866509",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "wHyvjt.tif",
    transform: "translate(6.072 3.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_972",
    "data-name": "Grupo 972",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_414",
    "data-name": "Trazado 414",
    d: "M21.424,36.823a15.023,15.023,0,0,1-1.534-.367,5.169,5.169,0,0,1-2.8-2.334.831.831,0,0,0-.664-.438c-2.218-.353-4.433-.73-6.649-1.1-.2-.033-.4-.07-.6-.1a.651.651,0,0,1-.6-.4.6.6,0,0,1,.211-.654,13.485,13.485,0,0,0,1.933-2.521,10.5,10.5,0,0,0,1.5-4.583c.12-1.831.089-3.671.144-5.506a14.606,14.606,0,0,1,.169-2.534A7.9,7.9,0,0,1,16.415,11a24.7,24.7,0,0,1,2.459-1.14,2.872,2.872,0,0,1,.954-2.31,2.583,2.583,0,0,1,1.838-.674A2.772,2.772,0,0,1,24.358,9.89c.407.137.831.26,1.24.419a7.877,7.877,0,0,1,5.289,7.674c.007,1.785,0,3.571.042,5.354A11.18,11.18,0,0,0,32.5,28.678,14.088,14.088,0,0,0,34.6,31.4c.181.187.342.382.241.674s-.35.366-.623.413c-1.661.284-3.32.576-4.982.856-.774.131-1.549.244-2.326.355a.615.615,0,0,0-.5.323,5.457,5.457,0,0,1-3.845,2.72c-.186.037-.375.057-.562.084Zm11.732-5.286a.416.416,0,0,0-.026-.1c-.058-.076-.116-.152-.178-.225a13.3,13.3,0,0,1-3.172-8.879c.01-1.509.007-3.018,0-4.526a5.942,5.942,0,0,0-.081-1.141,6.947,6.947,0,0,0-5.105-5.54,9.648,9.648,0,0,0-4.747-.254,8.031,8.031,0,0,0-4.484,2.358,6.746,6.746,0,0,0-1.911,4.845c.013,1.668.027,3.336-.008,5a12.787,12.787,0,0,1-2.194,7.064c-.314.463-.658.9-1.015,1.392l1.592.273a69.666,69.666,0,0,0,8.5,1.15,32.526,32.526,0,0,0,6.1-.309c1.793-.251,3.578-.574,5.366-.868C32.246,31.708,32.7,31.621,33.155,31.537ZM18.282,33.921a4.207,4.207,0,0,0,6.841,0A34.352,34.352,0,0,1,18.282,33.921ZM20.024,9.644H23.2a1.589,1.589,0,1,0-3.175,0Z",
    transform: "translate(-5.286 -6.875)",
    fill: "#866509"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_415",
    "data-name": "Trazado 415",
    d: "M34.653,21.772c-.127.476-.232.959-.387,1.426A5.855,5.855,0,0,1,32.9,25.4c-.288.3-.584.34-.84.114a.559.559,0,0,1,.022-.845,5.187,5.187,0,0,0,1.382-2.705,5.112,5.112,0,0,0-1.159-4.3c-.088-.106-.185-.205-.27-.314a.55.55,0,0,1,.035-.794.54.54,0,0,1,.771.06,5.836,5.836,0,0,1,1.408,2.208c.169.484.27.991.4,1.489Z",
    transform: "translate(-1.999 -5.532)",
    fill: "#866509"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_416",
    "data-name": "Trazado 416",
    d: "M5.689,21.031a6.234,6.234,0,0,1,1.74-4.346c.292-.31.61-.355.86-.124s.24.549-.056.868a5.228,5.228,0,0,0-.189,6.986c.089.106.187.2.27.313a.555.555,0,0,1-.023.774.517.517,0,0,1-.791-.056A10.857,10.857,0,0,1,6.418,23.96,5.806,5.806,0,0,1,5.689,21.031Z",
    transform: "translate(-5.689 -5.531)",
    fill: "#866509"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_417",
    "data-name": "Trazado 417",
    d: "M31.059,21.081a3.692,3.692,0,0,0-.88-2.608c-.056-.065-.114-.127-.165-.194a.553.553,0,0,1,.042-.772.536.536,0,0,1,.771.049,4.319,4.319,0,0,1,1.12,1.862,4.588,4.588,0,0,1-1.078,4.631.548.548,0,0,1-.714.151.488.488,0,0,1-.25-.622,1.135,1.135,0,0,1,.241-.365A3.4,3.4,0,0,0,31.059,21.081Z",
    transform: "translate(-2.282 -5.397)",
    fill: "#866509"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_418",
    "data-name": "Trazado 418",
    d: "M8.111,20.891a4.712,4.712,0,0,1,1.218-3.2c.331-.363.634-.423.9-.187s.232.557-.082.918a3.55,3.55,0,0,0-.17,4.591c.084.11.185.205.27.314a.55.55,0,1,1-.81.742A4.548,4.548,0,0,1,8.16,21.4C8.137,21.205,8.122,21.015,8.111,20.891Z",
    transform: "translate(-5.348 -5.397)",
    fill: "#866509"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_419",
    "data-name": "Trazado 419",
    d: "M14.28,16.807a5.335,5.335,0,0,1,3.331-4.46,8.01,8.01,0,0,1,6.547-.034c.37.151.528.407.436.7-.112.355-.4.45-.824.331a13.52,13.52,0,0,0-2.21-.543,6,6,0,0,0-4.751,1.36A3.873,3.873,0,0,0,15.381,17c-.016.413-.268.663-.6.629C14.415,17.6,14.253,17.323,14.28,16.807Z",
    transform: "translate(-4.479 -6.205)",
    fill: "#866509"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuNotificaciones);
export default __webpack_public_path__ + "static/media/ic_menu_notificaciones.3b392f842259c7071d46dc0459851f2d.svg";
export { ForwardRef as ReactComponent };